import availableStates from '@/helpers/availableStatesHelper'
import availableJobCategories from '@/helpers/availableJobCategoriesHelper'
import { availableCastingJobTypes } from '@/helpers/availableJobTypeHelper'
import availableEventCategories from '@/helpers/availableEventCategoriesHelper'

export default function() {
    return {
        availableStates,
        availableCities: [],
        isLoadingCities: false,
        availableJobCategories,
        availableCastingJobTypes,
        availableEventCategories,
        fixedEventTime: false,
        oneDayEvent: false,
        showDatePicker: [],
        showNormalizeInterval: true,
        jobDetails: {
            foodIncluded: false,
            uniformIncluded: false,
            socialClothing: false,
            uniformDetails: '',
            fee: {}
        },
        event: {
            title: null,
            place: '',
            category: '',
            isRemote: false,
            dates: [
                {
                    startDate: null,
                    endDate: null,
                    startTime: null,
                    endTime: null,
                    start: null,
                    end: null,
                    displayDate: null
                },
                {
                    startDate: null,
                    endDate: null,
                    startTime: null,
                    endTime: null,
                    start: null,
                    end: null,
                    displayDate: null
                }
            ],
            address: {
                zipCode: '',
                street: '',
                number: null,
                complement: '',
                neighbourhood: '',
                city: '',
                state: ''
            },
            profileSearches: []
        },
        errors: {
            'name': null,
            'address.zipCode': null,
            'address.street': null,
            'address.number': null,
            'address.complement': null,
            'address.neighbourhood': null,
            'address.city': null,
            'address.state': null,
            'start': null
        },
        successMessage: {
            show: false,
            content: null
        },
        errorMessage: {
            show: false,
            content: null
        },
        showCloningAlert: false,
        isSaved: false,
        unavailableDraftProfessionals: [],
        showUnavailableAlert: false,
    }
}
